import { z } from "zod"

export const AccountNumberSchema = z.object({
    accountNumber: z.string(),
})

export const PropertyIdSchema = z.object({
    propertyId: z.string(),
})

export const AgreementIdSchema = z.object({
    agreementId: z.coerce.number(),
})

const SupplyPointIdSchema = z.object({
    supplyPointId: z.string(),
})

export const HeadlessSchema = z.object({
    headless: z
        .string()
        .optional()
        .transform((param) => param === "true"),
})

export const DashboardPropertyParamsSchema = z.object({
    ...AccountNumberSchema.shape,
    ...PropertyIdSchema.shape,
})

export const DashboardPropertyAgreementParamsSchema = z.object({
    ...AccountNumberSchema.shape,
    ...PropertyIdSchema.shape,
    ...AgreementIdSchema.shape,
})

export const DashboardPropertySupplyPointParamsSchema = z.object({
    ...AccountNumberSchema.shape,
    ...PropertyIdSchema.shape,
    ...SupplyPointIdSchema.shape,
})

export const MeterPointIdsSchema = z.object({
    pceRef: z.string().optional(),
    prmId: z.string().optional(),
})
